module.exports = __webpack_public_path__ + "media/icon/icon-countertops-green-02aae218.svg";